export const langs = [
  { value: 'en', label: 'English', countryCode: 'GB' },
  { value: 'ar', label: 'العربية', countryCode: 'SA' },
];
